import type { Dispatch, PropsWithChildren } from 'react';
import { createContext, useReducer, type FC } from 'react';

export enum EConfirmSteps {
    ORDER_DETAILS = 0,
    VIRIFICATION_CODE = 1,
}

export enum Actions {
    SET_STEP = 'SET_STEP',
}

type ActionsType = {
    type: Actions;
    payload: EConfirmSteps;
};

type ConfirmContextState = {
    step: EConfirmSteps;
};

const initialState: ConfirmContextState = {
    step: EConfirmSteps.ORDER_DETAILS,
};

export const ConfirmContext = createContext<ConfirmContextState>(initialState);
export const ConfirmDispatchContext = createContext<Dispatch<ActionsType>>(() => null);

const confirmReducer = (state: ConfirmContextState, action: ActionsType) => {
    switch (action.type) {
    case Actions.SET_STEP:
        return {
            ...state,
            step: action.payload,
        };
    default:
        return state;
    }
};

export const ConfirmProvider: FC<PropsWithChildren> = ({ children }) => {
    const [state, dispatch] = useReducer(confirmReducer, initialState);

    return (
        <ConfirmContext.Provider value={state}>
            <ConfirmDispatchContext.Provider value={dispatch}>
                { children }
            </ConfirmDispatchContext.Provider>
        </ConfirmContext.Provider>
    );
};
